export default el => {
  const removeMargin = () => el.classList.add('teaserSimple--noMargin');

  const parent = el.parentNode;
  if (parent) {
    const next = parent.nextElementSibling;
    if (next) {
      if (next.classList && next.classList.contains('teaserSimple')) {
        removeMargin();
        return;
      } else {
        const child1 = next.childNodes[0];
        if (child1) {
          if (child1.classList && child1.classList.contains('teaserSimple')) {
            removeMargin();
            return;
          } else {
            const child2 = child1.childNodes[0];
            if (child2) {
              if (child2.classList && child2.classList.contains('teaserSimple')) {
                removeMargin();
                return;
              }
            }
          }
        }
      }
    }
    const parentParent = parent.parentNode;
    if (parentParent) {
      const next = parentParent.nextElementSibling;
      if (next) {
        if (next.classList && next.classList.contains('teaserSimple')) {
          removeMargin();
        } else {
          const child1 = next.childNodes[0];
          if (child1) {
            if (child1.classList && child1.classList.contains('teaserSimple')) {
              removeMargin();
            } else {
              const child2 = child1.childNodes[0];
              if (child2) {
                if (child2.classList && child2.classList.contains('teaserSimple')) {
                  removeMargin();
                }
              }
            }
          }
        }
      }
    }
  }
}
